import { render } from "./welcomepage.vue?vue&type=template&id=e684e2a0&scoped=true"
import script from "./welcomepage.vue?vue&type=script&lang=js"
export * from "./welcomepage.vue?vue&type=script&lang=js"

import "./welcomepage.vue?vue&type=style&index=0&id=e684e2a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e684e2a0"]])

export default __exports__